import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BoxWithLinksNew } from "../../Components/UI/UI";
import SimpleSlider from "../../Components/SimpleSlider/SimpleSlider";
import Accomodations from "../../Components/Accomodations/Accomodations";
import TourOperators from "../../Components/TourOperators/TourOperators";
import TagManager from 'react-gtm-module';
import "react-tabs/style/react-tabs.css";
import { isMobile } from "../../Utility/Utility";
import "./TptTabs.css";

const TptTabs = () => {
  return (
    <Tabs className={"ac-tpttabs"}>
      <TabList>
        <Tab>
          <div className="ac-inner-tab">
            <span>LOCAL OPERATORS LIST</span>
            <div className="ac-triangle"></div>
          </div>
        </Tab>
        <Tab>
          <div className="ac-inner-tab">
            <span>ACCOMODATIONS</span>
            <div className="ac-triangle"></div>
          </div>
        </Tab>
        <Tab>
          <div className="ac-inner-tab">
            <span>LOCAL TOURISM BOARDS</span>
            <div className="ac-triangle"></div>
          </div>
        </Tab>
      </TabList>

      <TabPanel>
        <TourOperators />
      </TabPanel>
      <TabPanel>
        <Accomodations />
      </TabPanel>
      <TabPanel>
        <BoxWithLinksNew
          wrapperCss={"1"}
          img={"Home/tourismboards/tourismboards1.jpg"}
          imgMob={"Home/tourismboards/tourismboards1mob.jpg"}
          imgMap={"mapwhite.png"}
          imgMobMap={"mapwhite.png"}
          title={"CENTRAL ISRAEL"}
          text={
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley"
          }
        >
          {" "}
          <a
            href="https://www.jda.gov.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Jerusalem',}})}
          >
            Jerusalem
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://visit.tel-aviv.gov.il/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':' Tel Aviv Jaffa',}})}
          >
            Tel Aviv Jaffa
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.m-yehuda.org.il/english/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':' Mateh Yehuda Regional Council',}})}
          >
            Mateh Yehuda Regional Council
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.thm.org.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':' Modiin-Region',}})}
          >
            Modiin-Region{" "}
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.binyaminregion.org.il/visit/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Binyamin',}})}
          >
            Binyamin
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://etziontour.org.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Gush Etzion',}})}
          >
            Gush Etzion
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.tourshomron.org.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Samaria',}})}
          >
            Samaria
          </a>
        </BoxWithLinksNew>
        <BoxWithLinksNew
          wrapperCss={"2"}
          img={"Home/tourismboards/tourismboards2.jpg"}
          imgMob={"Home/tourismboards/tourismboards2.jpg"}
          title={"NEGEV AND DEAD SEA"}
          imgMap={"mapwhite.png"}
          imgMobMap={"mapwhite.png"}
          text={
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy "
          }
        >
          <a
            href="https://www.deadsea.co.il/?lang=en"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':' Dead Sea',}})}
          >
            Dead Sea
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.beer-sheva.muni.il/Eng/Pages/default.aspx"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Beer Sheva',}})}
          >
            Beer Sheva
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://en.aravaway.co.il/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':' Arava - South',}})}
          >
            Arava - South
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.travelarad.com/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Arad',}})}
          >
            Arad
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.habsor.co.il/?lang=en"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Habsor',}})}
          >
            Habsor
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://visit-yerucham.com/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Yerucham',}})}
          >
            Yerucham
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://en.goarava.co.il/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Arava',}})}
          >
            Arava
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://eilat.city/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Eilat',}})}
          >
            Eilat
          </a>
        </BoxWithLinksNew>
        <BoxWithLinksNew
          wrapperCss={"3"}
          img={"Home/tourismboards/tourismboards3.jpg"}
          imgMob={"Home/tourismboards/tourismboards3.jpg"}
          title={"NORTHERN ISRAEL"}
          imgMap={"mapwhite.png"}
          imgMobMap={"mapwhite.png"}
          text={
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text "
          }
        >
          <a
            href="https://www.gogalilee.org/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Galilee',}})}
          >
            Galilee
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.akko.org.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Akko',}})}
          >
            Akko
          </a>
          <span className="ac-liner"> | </span>
          {/* <a
            href="https://zefat-online.co.il/tour/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Jerusalem',}})}
          >
            Zefat
          </a>
          <span className="ac-liner"> | </span> */}
          <a
            href="https://tourism.maianot.co.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Maianot Vally',}})}
          >
            Maianot Vally
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="//www.nazarethinfo.org/en"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Nazareth',}})}
          >
            Nazareth
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.bgalil.com/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'estern Galilee',}})}
          >
            Western Galilee
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.visit-haifa.org/eng/Discover_Haifa"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Haifa',}})}
          >
            Haifa
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://gonetanya.com/?lang=en"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Netanya',}})}
          >
            Netanya
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://en.ozrothagalil.org.il/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Trassures of the Galilee',}})}
          >
            Trassures of the Galilee
          </a>
          {/* <span className="ac-liner"> | </span>
          <a
            href="https://www.visit-tiberias.com/?language=eng"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Jerusalem',}})}
          >
            Tiberias Hotel Association
          </a> */}
          <span className="ac-liner"> | </span>
          <a
            href="https://www.carmelim.org.il/eng"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Carmelim',}})}
          >
            Carmelim
          </a>
          <span className="ac-liner"> | </span>
          <a
            href="https://www.wishtrip.com/site/100520000100156?fbclid=IwAR0Qwb67gTP9_Tk02S2V1l5pogYcwoeqMFXFez2pI7SgEx7clW-KowdbrEU"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'ashe Local Council',}})}
          >
            Menashe Local Council
          </a>

          <a
            href="https://www.westgalil.org.il/en/"
            target="_blank"
            rel="noopener"
            className="ac-tourist-board-links"
            onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'LOCAL TOURISM BOARDS', 'click_cta':'Western Galilee',}})}
          >
            Western Galilee
          </a>
        </BoxWithLinksNew>
      </TabPanel>
    </Tabs>
  );
};

export default TptTabs;



// WEBPACK FOOTER //
// ./src/Components/TptTabs/TptTabsMice.js